import { IProviderConfig } from '../../common/provider-config'
import { IAd } from '../ad'
import { AdTarget } from '../targeting/target'

/**
 * Supported ad bidding providers.
 * NOTE: these are the accepted values for `ads.bidding[].client` page conf.
 */
export enum AdBiddingProvider {
    AAX = 'aax',
    AMAZON = 'amazon',
    DISTRICT_M = 'districtm',
    INDEX_EXCHANGE = 'ix',
    MAGNITE = 'magnite',
}
export interface IAdServiceAdapter {
    ads: IAd[]
    adURI: string
    destroy(ads?: IAd[]): void
    initRequestAds(ads?: IAd[]): Promise<void>
    registerAd(ad: IAd): void
    registerVendors(): void
    requestAds(evt: Event, ads?: IAd[]): void
    target(targets: AdTarget[]): void
}
export interface IAdBiddingProviderConfig extends IProviderConfig {
    /**
     * Name of bidding provider.
     */
    client: AdBiddingProvider
}

export interface IGptAdapter extends IAdServiceAdapter {
    getIasScores(): Promise<string>
    storeAd(ad: IAd): void

    repopulateAds(): void
}

export interface IAdVerifierAdapter extends IGptAdapter {
    initializeVerifier(conf: IProviderConfig): void
}

/**
 * Supported tag manager providers.
 * NOTE: these are the accepted values for `ads.tags[].client` page conf.
 */
export enum TagManagerProvider {
    KRUX = 'krux',
}

export interface ITagManagerProviderConfig extends IProviderConfig {
    /**
     * Name of tag manager provider.
     */
    client: TagManagerProvider
}
